import React from 'react';
import { makeStyles } from '@material-ui/core';

import { escapeText } from '@root/utils/text.utils';

import caretDown from './icons/caretDown.svg';
import profile from './icons/profile.svg';
import star from './icons/star.svg';
import reply from './icons/reply.svg';
import dots from './icons/dots.svg';

const useStyles = makeStyles((theme) => ({
  emailAtomWrapper: {
    position: 'relative',
    padding: '12px',
  },
  logo: {
    width: '40px',
    borderRadius: theme.border.radius.default,
  },
  icon: {
    width: '15px',
    height: '15px',
  },
  companyInfo: {
    position: 'relative',
    left: '3rem',
    bottom: '2.25rem',
    fontFamily: 'Helvetica, Inter, sans-serif',
    lineHeight: '1.195rem',
  },
  companyNameWrap: {
    color: theme.palette.colors.darkGrey,
    fontSize: '0.9125rem',
    fontFamily: 'Roboto, RobotoDraft, Helvetica, Arial, sans-serif',
  },
  nameToWrap: {
    color: 'rgb(101, 103, 107)',
    fontSize: '0.85rem',
  },
  caretDown: {
    width: '10px',
    marginLeft: '3px',
  },
  iconsContainer: {
    display: 'flex',
    minWidth: '80px',
    justifyContent: 'space-between',
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  emailTitle: {
    margin: '0 5px 25px 5px',
  },
  emailBody: {
    lineHeight: '20px',
    marginTop: '-0.825rem',
    color: 'rgb(5, 5, 5)',
    font: 'small/ 1.5 Arial, Helvetica, sans-serif',
    cursor: 'pointer',
  },
}));

const SalesMailPreview = ({
  content: initialContent,
  fileData = {},
  onTextSelect = () => null,
}) => {
  const classes = useStyles();
  const { subject, emailBody } = initialContent;

  const [selectedField, setSelectedField] = React.useState(null);

  const onFieldSelect = (field) => () => setSelectedField(field);

  const onContentSelect = () => {
    const text = window.getSelection().toString().trim();

    if (!text || !escapeText(initialContent[selectedField]).includes(text)) {
      onTextSelect(null);
      return;
    }

    onTextSelect({
      text,
      field: selectedField,
    });
  };

  return (
    <div onMouseUp={onContentSelect}>
      <div className={classes.emailAtomWrapper}>
        <h3
          onMouseMove={onFieldSelect('subject')}
          className={classes.emailTitle}
        >
          {subject}
        </h3>
        <div className="companyInfoContainer">
          <div className={classes.headerWrapper}>
            <div>
              <img
                src={profile}
                alt="User profile"
                className={classes.logo}
              />
              <div className={classes.companyInfo}>
                <div className={classes.companyNameWrap}>
                  <b>{fileData.yourName}</b>
                  &nbsp;&lt;email@example.com&gt;
                </div>
                <div className={classes.nameToWrap}>
                  {`to ${fileData.leadName} `}
                  <img
                    src={caretDown}
                    alt="Caret Down"
                    className={classes.caretDown}
                  />
                </div>
              </div>
            </div>
            <div className={classes.iconsContainer}>
              <img
                src={star}
                alt="Star icon"
                className={classes.icon}
              />
              <img
                src={reply}
                alt="Reply icon"
                className={classes.icon}
              />
              <img
                src={dots}
                alt="Dots icon"
                className={classes.icon}
              />
            </div>
          </div>
          <div
            className={classes.emailBody}
            onMouseMove={onFieldSelect('emailBody')}
          >
            <div>
              <span>
                {emailBody.split('\n').map((para, idx) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={idx} style={{}}>
                    {para.trim() === '' ? <br /> : para}
                  </div>
                ))}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesMailPreview;
